import { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);


//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!email || !/\S+@\S+\.\S+/.test(email)) {
//       toast.error('Please enter a valid email address');
//       return;
//     }

//     setLoading(true);

//     // Simulate API response
//     setTimeout(() => {
//       toast.success('If this email is registered, a reset link has been sent.');
//       setLoading(false);
//       setTimeout(() => navigate('/'), 2500);
//     }, 1500);
//   };

const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      toast.error('Please enter a valid email address');
      return;
    }
  
    setLoading(true);
  
    // Simulate API error response
    setTimeout(() => {
      toast.error('Server error: Please try again later.');
      setLoading(false);
    }, 1500);
  };

  

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-white">
      <ToastContainer position="top-right" />
      <div className="w-full max-w-md bg-white shadow-xl rounded-xl p-8">
        <h2 className="text-2xl font-bold text-center mb-2 text-primary">Forgot Password</h2>
        <p className="text-xs text-gray-600 text-center mb-6">
          Enter your registered email to receive a password reset link.
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="email"
            placeholder="Your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-2 border rounded-full bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary"
          />

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-primary text-white py-2 rounded-full font-semibold hover:bg-opacity-90 disabled:opacity-60"
          >
            {loading ? 'Sending reset link...' : 'Send Reset Link'}
          </button>
        </form>
      </div>
    </div>
  );
}
